import attachment_chugoku_0 from '../../../../../assets/jp/attachments/chugoku_0.png';
import attachment_kansai_0 from '../../../../../assets/jp/attachments/kansai_0.png';
import attachment_kansai_1 from '../../../../../assets/jp/attachments/kansai_1.png';
import attachment_shikoku_0 from '../../../../../assets/jp/attachments/shikoku_0.png';
import attachment_shikoku_1 from '../../../../../assets/jp/attachments/shikoku_1.png';
import attachment_hokkaido_0 from '../../../../../assets/jp/attachments/hokkaido_0.png';

import poletop_chubu_0 from '../../../../../assets/jp/poletops/chubu_0.png';
import poletop_chubu_1 from '../../../../../assets/jp/poletops/chubu_1.png';
import poletop_chubu_2 from '../../../../../assets/jp/poletops/chubu_2.png';
import poletop_chugoku_0 from '../../../../../assets/jp/poletops/chugoku_0.png';
import poletop_hokuriku_0 from '../../../../../assets/jp/poletops/hokuriku_0.png';
import poletop_hokuriku_1 from '../../../../../assets/jp/poletops/hokuriku_1.png';
import poletop_kansai_0 from '../../../../../assets/jp/poletops/kansai_0.png';
import poletop_kansai_1 from '../../../../../assets/jp/poletops/kansai_1.png';
import poletop_kanto_0 from '../../../../../assets/jp/poletops/kanto_0.png';
import poletop_chugoku_shikoku_0 from '../../../../../assets/jp/poletops/chuugoku_shikoku_0.png';
import poletop_kanto_chugoku_okinawa_0 from '../../../../../assets/jp/poletops/kanto_chuugoku_okinawa_0.png';

import transformer_chubu_0 from '../../../../../assets/jp/transformers/chubu_0.png';
import transformer_chubu_1 from '../../../../../assets/jp/transformers/chubu_1.png';
import transformer_chubu_2 from '../../../../../assets/jp/transformers/chubu_2.png';
import transformer_chugoku_0 from '../../../../../assets/jp/transformers/chugoku_0.png';
import transformer_chugoku_1 from '../../../../../assets/jp/transformers/chugoku_1.png';
import transformer_chugoku_2 from '../../../../../assets/jp/transformers/chugoku_2.png';
import transformer_chugoku_3 from '../../../../../assets/jp/transformers/chugoku_3.png';
import transformer_chugoku_4 from '../../../../../assets/jp/transformers/chugoku_4.png';
import transformer_hokkaido_0 from '../../../../../assets/jp/transformers/hokkaido_0.png';
import transformer_hokkaido_1 from '../../../../../assets/jp/transformers/hokkaido_1.png';
import transformer_hokkaido_2 from '../../../../../assets/jp/transformers/hokkaido_2.png';
import transformer_hokuriku_0 from '../../../../../assets/jp/transformers/hokuriku_0.png';
import transformer_kansai_0 from '../../../../../assets/jp/transformers/kansai_0.png';
import transformer_kansai_1 from '../../../../../assets/jp/transformers/kansai_1.png';
import transformer_kansai_2 from '../../../../../assets/jp/transformers/kansai_2.png';
import transformer_kyushu_0 from '../../../../../assets/jp/transformers/kyushu_0.png';
import transformer_kyushu_1 from '../../../../../assets/jp/transformers/kyushu_1.png';
import transformer_okinawa_0 from '../../../../../assets/jp/transformers/okinawa_0.png';
import transformer_shikoku_0 from '../../../../../assets/jp/transformers/shikoku_0.png';
import transformer_shikoku_1 from '../../../../../assets/jp/transformers/shikoku_1.png';
import transformer_shikoku_2 from '../../../../../assets/jp/transformers/shikoku_2.png';
import transformer_tohoku_0 from '../../../../../assets/jp/transformers/tohoku_0.png';
import transformer_tohoku_1 from '../../../../../assets/jp/transformers/tohoku_1.png';
import transformer_tohoku_2 from '../../../../../assets/jp/transformers/tohoku_2.png';
import transformer_tokyo_0 from '../../../../../assets/jp/transformers/tokyo_0.png';
import transformer_tokyo_1 from '../../../../../assets/jp/transformers/tokyo_1.png';
import transformer_tokyo_2 from '../../../../../assets/jp/transformers/tokyo_2.png';
import transformer_tokyo_3 from '../../../../../assets/jp/transformers/tokyo_3.png';


export const ATTACHMENTS = [
    attachment_chugoku_0,
    attachment_kansai_0,
    attachment_kansai_1,
    attachment_shikoku_0,
    attachment_shikoku_1,
    poletop_chubu_0,
    poletop_chubu_1,
    poletop_chubu_2,
    poletop_chugoku_0,
    poletop_hokuriku_0,
    poletop_hokuriku_1,
    poletop_kansai_0,
    poletop_kansai_1,
    poletop_kanto_0,
    poletop_chugoku_shikoku_0,
    poletop_kanto_chugoku_okinawa_0,
    transformer_chubu_0,
    transformer_chubu_1,
    transformer_chubu_2,
    transformer_chugoku_0,
    transformer_chugoku_1,
    transformer_chugoku_2,
    transformer_chugoku_3,
    transformer_chugoku_4,
    transformer_hokkaido_0,
    transformer_hokkaido_1,
    transformer_hokkaido_2,
    transformer_hokuriku_0,
    transformer_kansai_0,
    transformer_kansai_1,
    transformer_kansai_2,
    transformer_kyushu_0,
    transformer_kyushu_1,
    transformer_okinawa_0,
    transformer_shikoku_0,
    transformer_shikoku_1,
    transformer_shikoku_2,
    transformer_tohoku_0,
    transformer_tohoku_1,
    transformer_tohoku_2,
    transformer_tokyo_0,
    transformer_tokyo_1,
    transformer_tokyo_2,
    transformer_tokyo_3,
    attachment_hokkaido_0,
];

export const REGION_INDEX_TO_ATTACHMENT_INDEX = [
    [3, 4, 14, 34, 35, 36],  // Shikoku
    [0, 8, 19, 20, 21, 22, 23, 14, 15], // Chugoku
    [31, 32], // Kyushu
    [5, 6, 7, 16, 17, 18], // Chubu
    [9, 10, 27], // Hokuriku
    [1, 2, 11, 12, 28, 29, 30], // Kansai
    [13, 40, 41, 42, 43, 15], // Kanto
    [37, 38, 39],   // Tohoku
    [24, 25, 26, 44],  // Hokkaido
    [33, 15],  // Okinawa
];

export const PREFECTURE_INDEX_TO_ATTACHMENT_INDEX = [
    [24, 25, 26],                             // Hokkaido
    [37, 38, 39],                             // Aomori (Tohoku)
    [37, 38, 39],                             // Iwate (Tohoku)
    [37, 38, 39],                             // Miyagi (Tohoku)
    [37, 38, 39],                             // Akita (Tohoku)
    [37, 38, 39],                             // Yamagata (Tohoku)
    [37, 38, 39],                             // Fukushima (Tohoku)
    [13, 40, 41, 42, 43, 15],                 // Ibaraki (Kanto)
    [13, 40, 41, 42, 43, 15],                 // Tochigi (Kanto)
    [13, 40, 41, 42, 43, 15],                 // Gunma (Kanto)
    [13, 40, 41, 42, 43, 15],                 // Saitama (Kanto)
    [13, 40, 41, 42, 43, 15],                 // Chiba (Kanto)
    [13, 40, 41, 42, 43, 15],                 // Tokyo (Kanto)
    [13, 40, 41, 42, 43, 15],                 // Kanagawa (Kanto)
    [37, 38, 39],                              // Niigata (Hokuriku)
    [9, 10, 27],                              // Toyama (Hokuriku)
    [9, 10, 27],                              // Ishikawa (Hokuriku)
    [9, 10, 27],                              // Fukui (Hokuriku)
    [5, 6, 7, 16, 17, 18],                    // Yamanashi (Chubu)
    [5, 6, 7, 16, 17, 18],                    // Nagano (Chubu)
    [5, 6, 7, 16, 17, 18],                    // Gifu (Chubu)
    [5, 6, 7, 16, 17, 18],                    // Shizuoka (Chubu)
    [5, 6, 7, 16, 17, 18],                    // Aichi (Chubu)
    [1, 2, 11, 12, 28, 29, 30, 5, 6, 7, 16, 17, 18],               // Mie (Kansai)
    [1, 2, 11, 12, 28, 29, 30],               // Shiga (Kansai)
    [1, 2, 11, 12, 28, 29, 30],               // Kyoto (Kansai)
    [1, 2, 11, 12, 28, 29, 30],               // Osaka (Kansai)
    [1, 2, 11, 12, 28, 29, 30],               // Hyogo (Kansai)
    [1, 2, 11, 12, 28, 29, 30],               // Nara (Kansai)
    [1, 2, 11, 12, 28, 29, 30],               // Wakayama (Kansai)
    [0, 8, 19, 20, 21, 22, 23, 14, 15],       // Tottori (Chugoku)
    [0, 8, 19, 20, 21, 22, 23, 14, 15],       // Shimane (Chugoku)
    [0, 8, 19, 20, 21, 22, 23, 14, 15],       // Okayama (Chugoku)
    [0, 8, 19, 20, 21, 22, 23, 14, 15],       // Hiroshima (Chugoku)
    [0, 8, 19, 20, 21, 22, 23, 14, 15],       // Yamaguchi (Chugoku)
    [3, 4, 14, 34, 35, 36],                   // Tokushima (Shikoku)
    [3, 4, 14, 34, 35, 36],                   // Kagawa (Shikoku)
    [3, 4, 14, 34, 35, 36],                   // Ehime (Shikoku)
    [3, 4, 14, 34, 35, 36],                   // Kochi (Shikoku)
    [31, 32],                                 // Fukuoka (Kyushu)
    [31, 32],                                 // Saga (Kyushu)
    [31, 32],                                 // Nagasaki (Kyushu)
    [31, 32],                                 // Kumamoto (Kyushu)
    [31, 32],                                 // Oita (Kyushu)
    [31, 32],                                 // Miyazaki (Kyushu)
    [31, 32],                                 // Kagoshima (Kyushu)
    [33, 15]                                  // Okinawa
];

export const ATTACHMENT_INDEX_TO_PREFECTURE_INDEX = [
    [30, 31, 32, 33, 34],                         // attachment_chugoku_0 -> Chugoku prefectures
    [23, 24, 25, 26, 27, 28, 29],                 // attachment_kansai_0 -> Kansai prefectures
    [23, 24, 25, 26, 27, 28, 29],                 // attachment_kansai_1 -> Kansai prefectures
    [35, 36, 37, 38],                             // attachment_shikoku_0 -> Shikoku prefectures
    [35, 36, 37, 38],                             // attachment_shikoku_1 -> Shikoku prefectures
    [18, 19, 20, 21, 22],                         // poletop_chubu_0 -> Chubu prefectures
    [18, 19, 20, 21, 22],                         // poletop_chubu_1 -> Chubu prefectures
    [18, 19, 20, 21, 22],                         // poletop_chubu_2 -> Chubu prefectures
    [30, 31, 32, 33, 34],                         // poletop_chugoku_0 -> Chugoku prefectures
    [15, 16, 17],                             // poletop_hokuriku_0 -> Hokuriku prefectures
    [15, 16, 17],                             // poletop_hokuriku_1 -> Hokuriku prefectures
    [23, 24, 25, 26, 27, 28, 29],                 // poletop_kansai_0 -> Kansai prefectures
    [23, 24, 25, 26, 27, 28, 29],                 // poletop_kansai_1 -> Kansai prefectures
    [7, 8, 9, 10, 11, 12, 13],                    // poletop_kanto_0 -> Kanto prefectures
    [30, 31, 32, 33, 34, 35, 36, 37, 38],         // chugoku_shikoku_0 -> Chugoku and Shikoku prefectures
    [7, 8, 9, 10, 11, 12, 13, 30, 31, 32, 33, 34, 46], // kanto_chugoku_okinawa_0 -> Kanto, Chugoku, and Okinawa prefectures
    [18, 19, 20, 21, 22],                         // transformer_chubu_0 -> Chubu prefectures
    [18, 19, 20, 21, 22],                         // transformer_chubu_1 -> Chubu prefectures
    [18, 19, 20, 21, 22],                         // transformer_chubu_2 -> Chubu prefectures
    [30, 31, 32, 33, 34],                         // transformer_chugoku_0 -> Chugoku prefectures
    [30, 31, 32, 33, 34],                         // transformer_chugoku_1 -> Chugoku prefectures
    [30, 31, 32, 33, 34],                         // transformer_chugoku_2 -> Chugoku prefectures
    [30, 31, 32, 33, 34],                         // transformer_chugoku_3 -> Chugoku prefectures
    [30, 31, 32, 33, 34],                         // transformer_chugoku_4 -> Chugoku prefectures
    [0],                                          // transformer_hokkaido_0 -> Hokkaido
    [0],                                          // transformer_hokkaido_1 -> Hokkaido
    [0],                                          // transformer_hokkaido_2 -> Hokkaido
    [15, 16, 17],                             // transformer_hokuriku_0 -> Hokuriku prefectures
    [23, 24, 25, 26, 27, 28, 29],                 // transformer_kansai_0 -> Kansai prefectures
    [23, 24, 25, 26, 27, 28, 29],                 // transformer_kansai_1 -> Kansai prefectures
    [23, 24, 25, 26, 27, 28, 29],                 // transformer_kansai_2 -> Kansai prefectures
    [39, 40, 41, 42, 43, 44, 45],                 // transformer_kyushu_0 -> Kyushu prefectures
    [39, 40, 41, 42, 43, 44, 45],                 // transformer_kyushu_1 -> Kyushu prefectures
    [46],                                         // transformer_okinawa_0 -> Okinawa
    [35, 36, 37, 38],                             // transformer_shikoku_0 -> Shikoku prefectures
    [35, 36, 37, 38],                             // transformer_shikoku_1 -> Shikoku prefectures
    [35, 36, 37, 38],                             // transformer_shikoku_2 -> Shikoku prefectures
    [1, 2, 3, 4, 5, 14, 6],                           // transformer_tohoku_0 -> Tohoku prefectures
    [1, 2, 3, 4, 5, 14, 6],                           // transformer_tohoku_1 -> Tohoku prefectures
    [1, 2, 3, 4, 5, 14, 6],                           // transformer_tohoku_2 -> Tohoku prefectures
    [7, 8, 9, 10, 11, 12, 13],                    // transformer_tokyo_0 -> Kanto prefectures
    [7, 8, 9, 10, 11, 12, 13],                    // transformer_tokyo_1 -> Kanto prefectures
    [7, 8, 9, 10, 11, 12, 13],                    // transformer_tokyo_2 -> Kanto prefectures
    [7, 8, 9, 10, 11, 12, 13]                     // transformer_tokyo_3 -> Kanto prefectures
];

export const HIGHLIGHT_GROUPS = [
    [0],                                      // Hokkaido
    [1, 2, 3, 4, 5, 6, 14],                   // Aomori - Tohoku region + Niigata
    [1, 2, 3, 4, 5, 6, 14],                   // Iwate - Tohoku region + Niigata
    [1, 2, 3, 4, 5, 6, 14],                   // Miyagi - Tohoku region + Niigata
    [1, 2, 3, 4, 5, 6, 14],                   // Akita - Tohoku region + Niigata
    [1, 2, 3, 4, 5, 6, 14],                   // Yamagata - Tohoku region + Niigata
    [1, 2, 3, 4, 5, 6, 14],                   // Fukushima - Tohoku region + Niigata
    [7, 8, 9, 10, 11, 12, 13],                // Ibaraki - Kanto region
    [7, 8, 9, 10, 11, 12, 13],                // Tochigi - Kanto region
    [7, 8, 9, 10, 11, 12, 13],                // Gunma - Kanto region
    [7, 8, 9, 10, 11, 12, 13],                // Saitama - Kanto region
    [7, 8, 9, 10, 11, 12, 13],                // Chiba - Kanto region
    [7, 8, 9, 10, 11, 12, 13],                // Tokyo - Kanto region
    [7, 8, 9, 10, 11, 12, 13],                // Kanagawa - Kanto region
    [1, 2, 3, 4, 5, 6, 14],                                      // Niigata (isolated)
    [15, 16, 17],                             // Toyama - Hokuriku region
    [15, 16, 17],                             // Ishikawa - Hokuriku region
    [15, 16, 17],                             // Fukui - Hokuriku region
    [20, 21, 22, 19, 23, 18],                                 // Yamanashi - Extended Chubu region + Nagano and Mie
    [20, 21, 22, 19, 23, 18],                                      // Nagano (isolated)
    [20, 21, 22, 19, 23, 18],                 // Gifu - Extended Chubu region + Nagano and Mie
    [20, 21, 22, 19, 23, 18],                 // Shizuoka - Extended Chubu region + Nagano and Mie
    [20, 21, 22, 19, 23, 18],                 // Aichi - Extended Chubu region + Nagano and Mie
    [20, 21, 22, 19, 23, 18],                                      // Mie (isolated)
    [24, 25, 26, 27, 28, 29, 23],             // Shiga - Kansai region + Mie
    [24, 25, 26, 27, 28, 29, 23],             // Kyoto - Kansai region + Mie
    [24, 25, 26, 27, 28, 29, 23],             // Osaka - Kansai region + Mie
    [24, 25, 26, 27, 28, 29, 23],             // Hyogo - Kansai region + Mie
    [24, 25, 26, 27, 28, 29, 23],             // Nara - Kansai region + Mie
    [24, 25, 26, 27, 28, 29, 23],             // Wakayama - Kansai region + Mie
    [30, 31, 32, 33, 34],                     // Tottori - Chugoku region
    [30, 31, 32, 33, 34],                     // Shimane - Chugoku region
    [30, 31, 32, 33, 34],                     // Okayama - Chugoku region
    [30, 31, 32, 33, 34],                     // Hiroshima - Chugoku region
    [30, 31, 32, 33, 34],                     // Yamaguchi - Chugoku region
    [35, 36, 37, 38],                         // Tokushima - Shikoku region
    [35, 36, 37, 38],                         // Kagawa - Shikoku region
    [35, 36, 37, 38],                         // Ehime - Shikoku region
    [35, 36, 37, 38],                         // Kochi - Shikoku region
    [39, 40, 41, 42, 43, 44, 45],             // Fukuoka - Kyushu region
    [39, 40, 41, 42, 43, 44, 45],             // Saga - Kyushu region
    [39, 40, 41, 42, 43, 44, 45],             // Nagasaki - Kyushu region
    [39, 40, 41, 42, 43, 44, 45],             // Kumamoto - Kyushu region
    [39, 40, 41, 42, 43, 44, 45],             // Oita - Kyushu region
    [39, 40, 41, 42, 43, 44, 45],             // Miyazaki - Kyushu region
    [39, 40, 41, 42, 43, 44, 45],             // Kagoshima - Kyushu region
    [46],                                     // Okinawa
];